import { render, staticRenderFns } from "./ErrorLogsTable.vue?vue&type=template&id=4dc1ea6c&scoped=true"
import script from "./ErrorLogsTable.vue?vue&type=script&lang=js"
export * from "./ErrorLogsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc1ea6c",
  null
  
)

export default component.exports